import React, { forwardRef } from 'react';

import { Field, FieldProps } from '@reckon-web/field';
import { CurrencyInput, CurrencyInputProps } from '@reckon-web/currency-input';

export type CurrencyFieldProps = CurrencyInputProps & FieldProps;

export const CurrencyField = forwardRef<HTMLInputElement, CurrencyFieldProps>(
  function CurrencyField(
    {
      description,
      helpText,
      id,
      invalidMessage,
      label,
      labelVisible,
      reserveMessageSpace,
      ...inputProps
    },
    inputRef
  ) {
    return (
      <Field
        description={description}
        helpText={helpText}
        id={id}
        invalidMessage={invalidMessage}
        label={label}
        labelVisible={labelVisible}
        reserveMessageSpace={reserveMessageSpace}
      >
        <CurrencyInput ref={inputRef} {...inputProps} />
      </Field>
    );
  }
);
